export const submitAnswer = async (form) => {
  const data = new FormData(form);
  const response = await fetch(form.action, {
    method: form.method,
    body: data
  });
  if (response.status !== 200) {
    throw new Error("received a non 200 status code");
  }
  const answer = await response.json();
  if (answer.hasNext) {
    return answer;
  } else {
    return answer;
  }
};
